export default {
  RESET_CURRENT_USER: "RESET_CURRENT_USER",
};
